import { Box } from '@mui/material'
import { FormikProps } from 'formik'
import Button from '~/src/components/mui-wrappers/buttons/Button'
import { useTranslations } from '~/src/hooks/useTranslations'
import { ConfirmationCodeFormInterface } from '~/src/types/forms/ConfirmationCodeFormInterface'
import useAuthenticationFlowConfirmationCodeResend
  from '~/src/hooks/auth/flow/useAuthenticationFlowConfirmationCodeResend'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'

interface Props {
  loading: boolean,
  form: FormikProps<ConfirmationCodeFormInterface>,
  showBackButton?: boolean,
}

const ConfirmationCodeFormActions = ({ loading, form, showBackButton = false }: Props) => {
  const { t } = useTranslations()
  const { resend, resendIn } = useAuthenticationFlowConfirmationCodeResend()
  const { restart } = useAuthenticationFlowDialogs()
  
  return (
    <Box sx={{
      display: 'grid',
      gridTemplateAreas: '"button" "resend"',
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'max-content',
      gap: 1
    }}
    >
      <Button
        loading={loading}
        disabled={!form.isValid || showBackButton}
        variant='contained'
        type='submit'
        sx={{
          gridArea: 'button',
          width: '100%',
          fontWeight: 'bold',
          fontSize: '1em'
        }}
      >
        {t('global.continue')}
      </Button>

      <Button
        disabled={!form.isValid || !!resendIn || showBackButton || loading}
        variant='outlined'
        onClick={resend}
        sx={{
          gridArea: 'resend',
          width: '100%',
          fontWeight: 'bold',
          fontSize: '1em'
        }}
      >
        {resendIn && (<>{t('global.resendIn')}{` ${resendIn}`}</>)}
        {!resendIn && (<>{t('global.resend')}</>)}
      </Button>

      { showBackButton && (
        <Button
          disabled={loading}
          variant='text'
          fullWidth
          onClick={restart}
        >
          {t('actions.previous')}
        </Button>
      )}
    </Box>
  )
}

export default ConfirmationCodeFormActions
